import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import type {
  FeatureFlagRecord,
  RemoveFeatureFlagRolloutGroupsRequest,
} from "../FeatureFlagRecord";

import * as UseCheckFeatureFlag from "./useCheckFeatureFlag";
import * as UseFeatureFlags from "./useFeatureFlags";

interface RemoveFeatureFlagRolloutGroupsArgs {
  featureFlagId: string;
  request: RemoveFeatureFlagRolloutGroupsRequest;
}

export function useRemoveFeatureFlagRolloutGroups() {
  const { featureFlagService } = useDomainServices();
  const queryClient = useQueryClient();

  return useMutation<
    FeatureFlagRecord,
    Error,
    RemoveFeatureFlagRolloutGroupsArgs
  >({
    mutationFn: ({ featureFlagId, request }) =>
      featureFlagService.removeRolloutGroups(featureFlagId, request),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: UseFeatureFlags.getQueryKey(),
      });
      void queryClient.invalidateQueries({
        queryKey: UseCheckFeatureFlag.getQueryKey(),
      });
    },
  });
}
